<template>
  <div class="animated fadeIn">
    <b-row v-for="(row, index) in rows" :key="index">
      <b-col v-for="(tileItem, index) in row" :key="index">
        <dashboard-tile :item="tileItem"></dashboard-tile>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DashboardTile from "./DashboardTile";

export default {
  components: { DashboardTile },
  name: "DashboardTiles",
  props: ["items"],
  data() {
    return {
      rows: []
    };
  },
  mounted() {
    if (this.items.length) {
      let i,
        j,
        chunk = 4;
      for (i = 0, j = this.items.length; i < j; i += chunk) {
        this.rows.push(this.items.slice(i, i + chunk));
      }
    }
  }
};
</script>
